module.exports = __webpack_public_path__ + "img/code.1b00ab5.png";